import { jsx } from "react/jsx-runtime";
import AgentSearch from "./AgentSearch.esm.js";
const BlockAgentSearch = {
  Component: ({
    attrs
  }) => {
    const {
      search = "zip",
      placeholder = "Enter Zip Code",
      disabled
    } = attrs;
    return /* @__PURE__ */ jsx(AgentSearch, { search, placeholder, disabled });
  },
  metadata: {
    version: "1.0",
    name: "constellation/agent-search",
    title: "Agent Search",
    description: "Search for real estate agents.",
    icon: "businessperson",
    keywords: ["searches", "agents", "premier"],
    supports: {
      customClassName: false,
      html: false
    },
    category: "Search",
    attributes: {
      search: {
        type: "string",
        default: "zip",
        label: "Search Type",
        control: "select",
        choices: [{
          label: "Zip",
          value: "zip"
        }, {
          label: "Installations",
          value: "installation"
        }]
      },
      placeholder: {
        type: "string",
        label: "Placeholder",
        default: "Enter Zip Code",
        control: "text"
      }
    }
  }
};
export {
  BlockAgentSearch as default
};
